import type { UpdateLabProfileInput } from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';

/** Saves the company details every letterhead and slip prints. */
export function saveLabProfile(input: UpdateLabProfileInput): Promise<unknown> {
  return api.patch(ENDPOINT.labProfile, input);
}

/** Asks Postgres to refresh its planner statistics. */
export function analyzeDatabase(): Promise<unknown> {
  return api.post(ENDPOINT.dbHealthAnalyze, {});
}
